// Logout.js
import React from 'react';
import { useNavigate } from 'react-router-dom'
import { auth } from '../firebase';

const Logout = () => {
  const Navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      Navigate.push('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Logging out...</h2>
        </div>
        <div className="text-center">
          <button
            onClick={handleLogout}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default Logout;
